'use client';

import { usePathname } from 'next/navigation';
import { Header } from './Header';

export function ConditionalHeader() {
  const pathname = usePathname();
  if (pathname === '/about') return null;
  if (pathname?.startsWith('/word-addin')) return null;
  return <Header />;
}
